var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionNoteReqWidgetDash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "27 18 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 24.3333H35M32.3333 26.6667H37M35 32C38.3137 32 41 29.3137 41 26C41 22.6863 38.3137 20 35 20C31.6863 20 29 22.6863 29 26C29 26.7981 29.1558 27.5598 29.4387 28.2563C29.4928 28.3897 29.5199 28.4563 29.532 28.5102C29.5438 28.5629 29.5481 28.6019 29.5481 28.6559C29.5481 28.7111 29.5381 28.7713 29.5181 28.8916L29.1228 31.2635C29.0814 31.5119 29.0607 31.6361 29.0992 31.7259C29.1329 31.8045 29.1955 31.8671 29.2741 31.9008C29.3639 31.9393 29.4881 31.9186 29.7365 31.8772L32.1084 31.4819C32.2287 31.4619 32.2889 31.4519 32.3441 31.4519C32.3981 31.4519 32.4371 31.4562 32.4898 31.468C32.5437 31.4801 32.6103 31.5072 32.7437 31.5613C33.4402 31.8442 34.2019 32 35 32Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionNoteReqWidgetDash);
export default __webpack_public_path__ + "static/media/sessionNoteReqWidgetDash.aec1ba1a24f7faf80bced1cea922e2c6.svg";
export { ForwardRef as ReactComponent };